import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as paymentService from '../services/paymentService'; // We'll create this next
import './SubmitPaymentProofPage.css'; // For basic styling

const SubmitPaymentProofPage = () => {
    const navigate = useNavigate();
    const [amount, setAmount] = useState(''); // Amount paid by the user
    const [paymentDate, setPaymentDate] = useState(''); // Date of payment
    const [bank, setBank] = useState(''); // Bank used by the user (Poste, etc,.)
    const [transactionId, setTransactionId] = useState(''); // Optional transaction ID
    const [proofImage, setProofImage] = useState(null); // File object for the screenshot
    const [notes, setNotes] = useState(''); // Additional notes from the user

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');
        setIsSuccess(false);

        // Basic validation
        if (!amount || !paymentDate || !bank || !proofImage) {
            setMessage('Please fill in all required fields (Amount, Date, Bank, and upload Proof Image).');
            setLoading(false);
            return;
        }

        try {
            // Call the service to submit the payment proof
            const response = await paymentService.submitPaymentProof({
                amount,
                paymentDate,
                bank,
                transactionId,
                proofImage, // This will be the File object
                notes,
            });

            setMessage('Payment proof submitted successfully! Your account will be reviewed shortly.');
            setIsSuccess(true);
            // Optionally clear the form or redirect after a short delay
            setTimeout(() => {
                navigate('/dashboard'); // Or a dedicated "Payment Pending" page
            }, 3000);

        } catch (error) {
            console.error('Error submitting payment proof:', error);
            setMessage(error.message || 'Failed to submit payment proof. Please try again.');
            setIsSuccess(false);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="submit-proof-container">
            <h1>Submit Payment Proof</h1>
            <p className="description">
                Please provide details of your bank transfer and upload a screenshot of your receipt.
            </p>
            <form onSubmit={handleSubmit} className="payment-proof-form">
                <div className="form-group">
                    <label htmlFor="amount">Amount Paid (USD) [It would be estimated in XOF, our local currency ]</label>
                    <input
                        type="number" // Use number type for amount
                        id="amount"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        required
                        min="1" // Ensure positive amount
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="paymentDate">Date of Payment:</label>
                    <input
                        type="date"
                        id="paymentDate"
                        value={paymentDate}
                        onChange={(e) => setPaymentDate(e.target.value)}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="bank">Bank Used:</label>
                    <select
                        id="bank"
                        value={bank}
                        onChange={(e) => setBank(e.target.value)}
                        required
                    >
                        <option value="">Select a bank</option>
                        <option value="Poste du Togo">La Poste du Togo</option>
                        {/* Add more options if you have other banks */}
                    </select>
                </div>

                <div className="form-group">
                    <label htmlFor="transactionId">Transaction ID/Reference (Optional):</label>
                    <input
                        type="text"
                        id="transactionId"
                        value={transactionId}
                        onChange={(e) => setTransactionId(e.target.value)}
                        placeholder="e.g., Bank Ref, Deposit Slip No."
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="proofImage">Upload Payment Screenshot/Receipt:</label>
                    <input
                        type="file"
                        id="proofImage"
                        accept="image/*" // Accept any image type
                        onChange={(e) => setProofImage(e.target.files[0])}
                        required
                    />
                    <small>Accepted formats: JPG, PNG. Max size: 5MB.</small>
                </div>

                <div className="form-group">
                    <label htmlFor="notes">Additional Notes (Optional):</label>
                    <textarea
                        id="notes"
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        rows="4"
                        placeholder="Any other details that might help verification."
                    ></textarea>
                </div>

                <button type="submit" className="submit-button" disabled={loading}>
                    {loading ? 'Submitting...' : 'Submit Proof'}
                </button>

                {message && (
                    <p className={`status-message ${isSuccess ? 'success' : 'error'}`}>
                        {message}
                    </p>
                )}
            </form>
        </div>
    );
};

export default SubmitPaymentProofPage;